import { render, staticRenderFns } from "./UserProfilePicture.vue?vue&type=template&id=5d5dc478&scoped=true&"
import script from "./UserProfilePicture.vue?vue&type=script&lang=ts&"
export * from "./UserProfilePicture.vue?vue&type=script&lang=ts&"
import style0 from "./UserProfilePicture.vue?vue&type=style&index=0&id=5d5dc478&prod&lang=scss&"
import style1 from "./UserProfilePicture.vue?vue&type=style&index=1&id=5d5dc478&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5dc478",
  null
  
)

export default component.exports